import React from 'react';
import clientLogos from '../../data/clientLogos';
import { useT } from '../../i18n/LanguageContext';
import strings from './LogoMarquee.i18n';
import './LogoMarquee.css';

export default function LogoMarquee() {
  const t = useT(strings);
  // Double the logos for seamless infinite scroll
  const logos = [...clientLogos, ...clientLogos];

  return (
    <section className="logo-marquee">
      <p className="logo-marquee__heading">{t.heading}</p>
      <p className="logo-marquee__label">{t.label}</p>
      <div className="logo-marquee__track">
        <div className="logo-marquee__slider">
          {logos.map((logo, idx) => (
            <div key={`${logo.name}-${idx}`} className="logo-marquee__item">
              <img
                src={process.env.PUBLIC_URL + logo.logoSrc}
                alt={logo.name}
                className="logo-marquee__img"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
